var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./CommonTraineesGallery.jinja');
require('./CommonTraineesGallery.less');

var objectFitImages = require('object-fit-images');
require('assets/owl.carousel.min.css');
require('assets/owl.theme.default.min.css');
require('owl.carousel.min-2.2.1.js');

module.exports = Base.extend({

    template: template,


    initialize: function (options) {
        this.options = options || {};

        Base.prototype.initialize.call(this, options);
    },


    viewsRegistration: function () {
        Base.prototype.viewsRegistration.call(this);

        this.initGallery();
    },


    destroy: function () {
        this.destroyed = true;

        return Base.prototype.destroy.call(this);
    },


    initGallery: function () {
        var carouselSelector = '.CommonTraineesGallery-galleryCarousel';
        var itemsCount = this.$('.CommonTraineesGallery-galleryItem').length;

        this.$(carouselSelector).owlCarousel({
            items: 4,
            nav: itemsCount > 4,
            dots: itemsCount > 2,
            dotsEach: Math.ceil(itemsCount / 10), //no more than 10 dots
            loop: itemsCount > 4,
            mouseDrag: false,
            smartSpeed: 300,
            // slideBy: 'page',
            slideBy: 4,
            responsive:{
                0:{
                    items: 2,
                    slideBy: 2
                },
                768:{
                    items: 4,
                    slideBy: 4
                }
            }
        });

        this.$(carouselSelector)
            .find('.owl-prev')
            .html(this.$('.CommonTraineesGallery-galleryPrev svg'));

        this.$(carouselSelector)
            .find('.owl-next')
            .html(this.$('.CommonTraineesGallery-galleryNext svg'));
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/CommonTraineesGallery/CommonTraineesGallery.js
// module id = 174
// module chunks = 0